document.addEventListener('DOMContentLoaded', function () {
    // For description & Grade on PDP
    function scrollAndOpenTab({
    triggerSelector,
    scrollTargetSelector,
    tabSelector,
    tabText
    }) {
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest(triggerSelector);
        if (!trigger) return;

        e.preventDefault();

        // Scroll to section
        const scrollTarget = document.querySelector(scrollTargetSelector);
        if (scrollTarget) {
        scrollTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        }

        // Activate tab
        let tab = null;

        if (tabSelector) {
        tab = document.querySelector(tabSelector);
        } else if (tabText) {
        tab = [...document.querySelectorAll('.tabs__item-label')]
            .find(el => el.textContent.trim().includes(tabText));
        }

        if (tab) tab.click();
    });
    }

    // scrollAndOpenTab({
    // triggerSelector: '#grade_info',
    // scrollTargetSelector: '#tabs__content_product',
    // tabText: 'Grade'
    // });
    scrollAndOpenTab({
    triggerSelector: '#description_info',
    scrollTargetSelector: '#tabs__content_product',
    tabText: 'description'
    });

    // After Pay on PDP
    document.querySelectorAll('.after_pay_link').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            var modal = document.querySelector('afterpay-modal');
            if (modal) {
            modal.setAttribute('visible', 'visible');

            modal.setAttribute('data-modal-id', '');
            modal.setAttribute('data-locale', 'en_NZ');
            modal.setAttribute('data-modal-theme', 'mint');
            modal.setAttribute('data-apr-loans-available', 'false');
            modal.setAttribute('data-brand-name', 'afterpay');
            }
        });
    });

    // Add on Product on PDP
    function techupProtectDetails(){
        const interval_ = setInterval(() => {
          const optionContainer = document.querySelector('.easify-product-options .tpo_option-set-container .tpo_option-container');
          if (optionContainer ) {
              clearInterval(interval_);

            if (optionContainer && !document.querySelector('#custom-techup-protect')) {
              const newDiv = document.createElement('div');
              newDiv.id = 'custom-techup-protect';
              newDiv.innerHTML = `
                <div class="tooltip-wrapper">
                  <span class="tooltip-icon">Details</span>
                  <div class="tooltip-content">
                    <ul>
                      <li><strong class="ql-size-small">12 Months + 1 Year Extended Warranty </strong></li>
                      <li><strong class="ql-size-small">Free Postage for approved claims</strong></li>
                      <li><strong class="ql-size-small" style="color: rgb(0, 0, 0);">Damaged your device? Don't worry, we've got you covered!&nbsp;(Additional charges apply)</strong></li>
                      <li><strong class="ql-size-small">Hassle-Free Process with Quick Resolutions</strong></li>
                      <li><strong class="ql-size-small">&#xFEFF;</strong><a href="https://techup.nz/pages/techup-care-terms-of-service" rel="noopener noreferrer" target="_blank" class="ql-size-small"><strong><u>Click Here for Detailed T&amp;C's</u></strong></a></li>
                    </ul>
                  </div>
                </div>
              `;
            
              // ✅ Insert AFTER .tpo_option-container
              optionContainer.insertAdjacentElement('afterend', newDiv);
            }
          }
        }, 200);
      }

      techupProtectDetails();

    //   For Tech Protect Details
      document.addEventListener('click', function (e) {
        const tooltip = e.target.closest('.tooltip-wrapper');
        document.querySelectorAll('.tooltip-wrapper').forEach(t => {
          if (t !== tooltip) t.classList.remove('active');
        });
        if (tooltip) tooltip.classList.toggle('active');
      });

    // Add active class to tabs on PDP
    function setFirstTabActive() {
      const tabLists = document.querySelectorAll(
        '#tabs__content_product .tabs__title-list__content'
      );

      tabLists.forEach(tabList => {
        const firstLi = tabList.querySelector('li');
        if (firstLi && !tabList.querySelector('li.active')) {
          firstLi.classList.add('active');
        }
      });
    }

    // Run on initial load
    setFirstTabActive();

    // Run again after Shopify section load (VERY IMPORTANT)
    document.addEventListener('shopify:section:load', setFirstTabActive);
    document.addEventListener('click', function (e) {
      const tabLabel = e.target.closest('#tabs__content_product .tabs__item-label');
      if (!tabLabel) return;

      const tabList = tabLabel.closest('#tabs__content_product .tabs__title-list__content');
      if (!tabList) return;

      // Remove active class from all <li>
      tabList.querySelectorAll('li').forEach(li => {
        li.classList.remove('active');
      });

      // Add active class to clicked <li>
      const parentLi = tabLabel.closest('li');
      if (parentLi) {
        parentLi.classList.add('active');
      }
    });

    // Sold Out Count On mobile PDP
    const interval1_ = setInterval(() => {
      const optionContainer = document.querySelector('.template-product  .soldcount-container');
      const targetEl = document.querySelector('.template-product .product__title');

      if (optionContainer && targetEl) {
        clearInterval(interval1_);
        targetEl.insertAdjacentHTML(
          'beforeend',
          optionContainer.innerHTML
        );
      }
    }, 200);


  // check TechUp Protect
  let techProtectAdded = false;
  function checktechupProtect() {
      document.querySelectorAll('.cart-items tr.cart-item').forEach((item) => {
        // Find addon/order estimation label safely
        const orderDt = item.querySelector(
          '.cart-item__details dl .product-option dt'
        );

        if (!orderDt) return;

        const text = orderDt.textContent.replace(/\s+/g, ' ').trim();

      // Match your condition
      if (/techup protect/i.test(text)) {
         techProtectAdded = true;
        // item.querySelector('cart-remove-button button').click();
      }
    });
  }


  function removeMainAndAddonSafely(btn) {
    console.log('remove function call');

    const cartItem_ = btn.closest('tr.cart-item');
    if (!cartItem_) return;

    const removeButton = cartItem_.querySelector('cart-remove-button');
    if (!removeButton) return;

    const mainLineIndex = Number(removeButton.dataset.index);

    const cartItems_ =
      cartItem_.closest('cart-items') ||
      cartItem_.closest('cart-drawer-items');

    if (!cartItems_ || !cartItems_.updateQuantity) return;

    cartItems_.updateQuantity(mainLineIndex, 0);

    //  Read addon variant ID BEFORE removal
    let addonVariantId = null;

    const addonAttr =
      cartItem_.dataset.tpoAddOnVariantIds ||
      cartItem_.getAttribute('data-tpo-add-on-variant-ids');

    if (addonAttr) {
      try {
        addonVariantId = JSON.parse(addonAttr)[0];
      } catch (e) {
        addonVariantId = addonAttr;
      }
    }

    const allCartItems = cartItems_.querySelectorAll('.cart-item');

    let addonLineIndex = null;

    allCartItems.forEach(item => {
      const input = item.querySelector('input[name="updates[]"]');
      if (!input) return;

      if (input.dataset.quantityVariantId === addonVariantId) {
        addonLineIndex = Number(input.dataset.index);
      }
    });

    /* ---------- Remove ADD-ON first ------------ */
    setTimeout(function(){
      if (addonLineIndex !== null) {
        cartItems_.updateQuantity(addonLineIndex, 0);
      }
    },200)
    
  }

  // Save for later on Cart
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.swym-save-for-later-btn');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const productId = btn.dataset.productId;
    const productUrl = btn.dataset.productUrl;

    if (!window._swat) return;

    // Prevent double click
    if (btn.classList.contains('is-saved')) return;

    window._swat.addToWishList({
      epi: Number(variantId),
      empi: Number(productId),
      du: productUrl
    }, function () {

      // ✅ Update button UI
      btn.textContent = 'Saved';
      btn.classList.add('is-saved');
      btn.setAttribute('disabled', 'true');

      setTimeout(() => {

          //checktechupProtect();

          // Remove item using Shopify's CartItems logic
          const cartItem = btn.closest('tr.cart-item');
          if (!cartItem) return;


          const orderDt = cartItem.querySelector(
                '.cart-item__details dl .product-option dt'
              );

          if (!orderDt) return;

          const text = orderDt.textContent.replace(/\s+/g, ' ').trim();

          // Match your condition
          if (/techup protect/i.test(text)) {
            techProtectAdded = true;
          }

          const removeButton = cartItem.querySelector('cart-remove-button');
          if (!removeButton) return;

          const lineIndex = Number(removeButton.dataset.index);

          const cartItems =
            cartItem.closest('cart-items') ||
            cartItem.closest('cart-drawer-items');

          if (!cartItems || !cartItems.updateQuantity) return;

          cartItems.updateQuantity(lineIndex, 0);

          if(techProtectAdded){
            removeMainAndAddonSafely(btn);
          }
          
          updateCartCount();

      }, 1000); 


    });


  });

  // Update cart total count
  function updateCartCount(){
    setTimeout(function(){
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        console.log(cart.item_count);
        if(document.getElementById('cart_count')){
          document.getElementById('cart_count').innerHTML = `${cart.item_count} <span>items</span>`;
        }
      });
    },1500);
  }

  function updateCartCountFromCart(cartData) {
    const cartCountEl = document.getElementById('cart_count');
    if (!cartCountEl) return;

    cartCountEl.innerHTML = `${cartData.item_count} <span>items</span>`;
  }

  document.addEventListener('afterUpdateQuantity', function (e) {
    if (!e.detail || !e.detail.cartData) return;
    console.log('afterUpdateQuantity');
    updateCartCountFromCart(e.detail.cartData);
  });

  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('afterCartChanged', updateCartCount);

  document.addEventListener('afterCartChanged', function (e) {
    if (!e.detail || !e.detail.cartData) return;
    console.log(e);
    updateCartCount();
  });

  // ESTIMATE DELIVERY WIDGET ON CART DRAWER & CART Page
  function getFirstOrderEstimationDD() {
    const firstCartItem = document.querySelector('.cart-item');
    if (!firstCartItem) return null;
    if (!firstCartItem.querySelector('.tpo_cart-properties-wrapper .product-option dd')) return null;
    return firstCartItem.querySelector('.tpo_cart-properties-wrapper .product-option dd');
  }

  const DELIVERY_ICONS = {
    'Order Confirmed': 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_img136.gif',
    'Shipped': 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_img135.gif',
    'At Your Doorstep': 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_img133.gif'
  };

  function parseOrderEstimation(dd) {
    const text = dd.innerText.replace(/\s+/g, ' ').trim();

    const heading = (text.match(/Estimated Delivery Date\s*(.*?)\s*Order Confirmed/i) || [])[1];

    const steps = [
      ['Order Confirmed', (text.match(/Order Confirmed\s*(.*?)\s*Shipped/i) || [])[1]],
      ['Shipped', (text.match(/Shipped\s*(.*?)\s*At Your Doorstep/i) || [])[1]],
      ['At Your Doorstep', (text.match(/At Your Doorstep\s*(.*)$/i) || [])[1]],
    ].filter(i => i[1]);

    return {
      heading,
      steps: steps.map(step => [
        step[0],
        step[1],
        DELIVERY_ICONS[step[0]]
      ])
    };
  }

  function createStepHTML(label, date, image) {
    return `
      <div class="delivery_step_wrap">
        <div class="delivery_step">
          <div class="step-icon"></div>
          <div class="three_step_card_img">
            <img 
              src="${image}" 
              alt="${label}" 
              loading="lazy"
            >
          </div>
        </div>
        <p class="step-date">
          ${label} <span>${date}</span>
        </p>
      </div>
    `;
  }

  function renderDeliveryTimeline() {
    const dd = getFirstOrderEstimationDD();
    if (!dd) return false;

    const parsed = parseOrderEstimation(dd);
    if (!parsed || !parsed.steps.length) return false;

    const container = document.querySelector('#estimated_delivery-block');
    if (!container) return false;

    container.innerHTML = `
      <h3 class="estimated-delivery-heading">
        Estimated Delivery Date <span>${parsed.heading}</span>
      </h3>
      <div class="delivery-steps">
        ${parsed.steps.map(s => createStepHTML(s[0], s[1], s[2])).join('')}
      </div>
    `;

    return true;
  }

  // ✅ FIXED: Uncommented and activated the delivery timeline loader
  // const cartLoadinterval = setInterval(() => {
  //   if (renderDeliveryTimeline()) {
  //     clearInterval(cartLoadinterval);
  //   }
  // }, 200);

  // Also trigger on cart updates
  // document.addEventListener('cart:updated', renderDeliveryTimeline);
  // document.addEventListener('afterCartChanged', renderDeliveryTimeline);


  //  Check ETA DELIVERY. : 
  function checkETACartLine() {
    document.querySelectorAll('.cart-items tr.cart-item').forEach((item) => {
      // Find addon/order estimation label safely
      const orderDt = item.querySelector(
        '.cart-item__details dl .product-option dt'
      );

      if (!orderDt) return;

      const text = orderDt.textContent.replace(/\s+/g, ' ').trim();

      // Match your addon condition
      if (/order estimation/i.test(text)) {
        item.classList.add('eta-delivery');
      } else {
        item.classList.remove('eta-delivery');
      }
    });
  }

  /* ---- Run once cart exists ---- */
  const addonCheckInterval = setInterval(() => {
    const cartExists = document.querySelector(
      '.cart-drawer, cart-drawer-items, form.cart__contents .cart-items'
    );

    if (cartExists) {
      clearInterval(addonCheckInterval);
      checkETACartLine();
    }
  }, 200);

  /* ---- Re-run on cart updates (important for AJAX carts) ---- */
  document.addEventListener('cart:updated', checkETACartLine);
  document.addEventListener('afterCartChanged', checkETACartLine);

});

/* ---- TU-JUL-122 : Cart Warranty Line item update On basis of PArent Line item ---- */

//  ON change warranty checkbox
const warrantyCheckbox = document.querySelector('.techup-warranty__checkbox');
const checkoutButton = document.querySelector('.product-form__buttons--input');

warrantyCheckbox?.addEventListener('change', function () {

  const option = warrantyCheckbox.closest('.techup-warranty__upgrade')
  ?.querySelector('.techup-warranty__option strong');

  option.textContent = warrantyCheckbox.checked ? '2-Year Warranty Selected –' : 'Upgrade to 2-Year Warranty -';

  // if (this.checked) {
  //   checkoutButton?.classList.add('warranty-added');
  // } else {
  //   checkoutButton?.classList.remove('warranty-added');
  // }
  updateAddonMessage();
  updateCheckoutButtonClass();
});



// Product checks
let isParentChildQuantityUpdating = false;

document.addEventListener('change', async function (event) {

  if (isParentChildQuantityUpdating) return;

  const quantityInput = event.target.closest(
    '.cart-item__quantity .quantity__input'
  );

  if (!quantityInput) return;

  const newQuantity = parseInt(quantityInput.value, 10);

  if (isNaN(newQuantity)) return;

  const lineKey = quantityInput.dataset.cartLineKey;

  if (!lineKey) {
    console.warn('Cart line key not found.');
    return;
  }

  try {

    isParentChildQuantityUpdating = true;

    /*
     * -----------------------------------------
     * GET CURRENT CART
     * -----------------------------------------
     */
    const cartResponse = await fetch(
      window.Shopify.routes.root + 'cart.js'
    );

    if (!cartResponse.ok) {
      throw new Error('Unable to fetch cart.');
    }

    const cart = await cartResponse.json();

    /*
     * -----------------------------------------
     * FIND CHANGED ITEM
     * -----------------------------------------
     */
    const parentItem = cart.items.find(
      item => item.key === lineKey
    );

    if (!parentItem) {
      console.warn('Cart item not found.');
      return;
    }

    /*
     * -----------------------------------------
     * CHILD ITEM CHECK
     *
     * If the changed item already has a
     * parent_relationship, it is a child.
     *
     * Do nothing when child quantity is changed
     * directly.
     * -----------------------------------------
     */
    if (parentItem.parent_relationship) {

      console.log(
        'Child item quantity changed. Ignoring update.'
      );

      return;
    }

    /*
     * -----------------------------------------
     * FIND CHILD ITEMS
     * -----------------------------------------
     */
    const childItems = cart.items.filter(item =>
      item.parent_relationship &&
      item.parent_relationship.parent_key === parentItem.key
    );

    /*
     * Only run this logic if the parent
     * actually has child products.
     */
    if (!childItems.length) {

      console.log(
        'Parent has no child items. Ignoring update.'
      );

      return;
    }

    /*
     * -----------------------------------------
     * STORE ORIGINAL QUANTITIES
     *
     * These are used if rollback is required.
     * -----------------------------------------
     */
    const originalQuantities = {
      [parentItem.key]: parentItem.quantity
    };

    childItems.forEach(childItem => {
      originalQuantities[childItem.key] =
        childItem.quantity;
    });

    /*
     * Nothing changed
     */
    if (newQuantity === parentItem.quantity) {
      return;
    }

    /*
     * -----------------------------------------
     * GET CART DRAWER & CART
     * -----------------------------------------
     */
    const cartDrawer =
      document.querySelector('cart-drawer');

    const cartItems =
    document.querySelector('cart-items');

    /*
     * Get sections that need to be rendered.
     */
    let sectionIds = [];

    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function'
    ) {
      sectionIds = cartDrawer
        .getSectionsToRender()
        .map(section => section.id);
    }

    /*
     * -----------------------------------------
     * HELPER: CHANGE CART LINE
     * -----------------------------------------
     */
    async function changeLineQuantity(lineKey, quantity) {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/change.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: quantity
          })
        }
      );

      let data = {};

      try {
        data = await response.json();
      } catch (error) {
        data = {};
      }

      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to update cart quantity.'
        );

      }

      return data;
    }

    /*
     * -----------------------------------------
     * HELPER: REFRESH CART DRAWER
     * -----------------------------------------
     */
    
    async function refreshCartDrawer() {

      if (
        !cartDrawer &&
        !cartItems
      ) {
        return;
      }

      /*
      * Get cart drawer sections
      */
      let sectionIds = [];

      if (
        cartDrawer &&
        typeof cartDrawer.getSectionsToRender === 'function'
      ) {
        sectionIds.push(
          ...cartDrawer
            .getSectionsToRender()
            .map(section => section.id)
        );
      }

      /*
      * Get cart page sections
      */
      if (
        cartItems &&
        typeof cartItems.getSectionsToRender === 'function'
      ) {
        sectionIds.push(
          ...cartItems
            .getSectionsToRender()
            .map(section => section.id)
        );
      }

      /*
      * Remove duplicate section IDs
      */
      sectionIds = [...new Set(sectionIds)];

      /*
      * Request updated cart sections
      */
      const refreshResponse = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            updates: {},
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        }
      );

      if (!refreshResponse.ok) {
        throw new Error(
          'Unable to refresh cart.'
        );
      }

      const refreshData =
        await refreshResponse.json();

      /*
      * Update CART PAGE
      */
      if (
        cartItems &&
        typeof cartItems.renderContents === 'function'
      ) {
        cartItems.renderContents(refreshData);
      }

      /*
      * Update CART DRAWER
      */
      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function'
      ) {
        cartDrawer.renderContents(refreshData);
      }

    }

    /*
     * -----------------------------------------
     * HELPER: SHOW ERROR
     * -----------------------------------------
     */
    function showQuantityError(message) {

      /*
       * Remove previous custom error.
       */
      const existingError =
        quantityInput
          .closest('.cart-item')
          ?.querySelector(
            '.parent-child-quantity-error'
          );

      if (existingError) {
        existingError.remove();
      }

      const cartItem =
        quantityInput.closest('.cart-item');

      if (!cartItem) {
        console.log(message);
        return;
      }

      const errorElement =
        document.createElement('div');

      errorElement.className =
        'parent-child-quantity-error';

      errorElement.textContent = message;

      errorElement.style.color = '#d72c0d';
      errorElement.style.fontSize = '13px';
      errorElement.style.marginTop = '5px';

      const quantityWrapper =
        quantityInput.closest(
          '.cart-item__quantity'
        );

      if (quantityWrapper) {

        // quantityWrapper.appendChild(
        //   errorElement
        // );

      } else {

        cartItem.appendChild(
          errorElement
        );
      }
    }

    /*
     * -----------------------------------------
     * KEEP TRACK OF SUCCESSFUL UPDATES
     *
     * Used for rollback.
     * -----------------------------------------
     */
    const successfullyUpdated = [];

    /*
     * -----------------------------------------
     * STEP 1
     *
     * UPDATE PARENT FIRST
     * -----------------------------------------
     */
    try {

      await changeLineQuantity(
        parentItem.key,
        newQuantity
      );

      successfullyUpdated.push(
        parentItem.key
      );

      console.log(
        'Parent quantity updated:',
        newQuantity
      );

    } catch (parentError) {

      console.error(
        'Parent quantity update failed:',
        parentError
      );

      /*
       * Restore input to original quantity.
       */
      quantityInput.value =
        parentItem.quantity;

      /*
       * Show Shopify error.
       */
      showQuantityError(
        parentError.message
      );

      /*
       * IMPORTANT:
       * Do NOT update any children.
       */
      return;
    }

    /*
     * -----------------------------------------
     * STEP 2
     *
     * UPDATE CHILDREN ONLY AFTER
     * PARENT UPDATE SUCCEEDS
     * -----------------------------------------
     */
    try {

      for (const childItem of childItems) {

        await changeLineQuantity(
          childItem.key,
          newQuantity
        );

        successfullyUpdated.push(
          childItem.key
        );

        console.log(
          'Child quantity updated:',
          childItem.key,
          newQuantity
        );
      }

    } catch (childError) {

      console.error(
        'Child quantity update failed:',
        childError
      );

      /*
       * -----------------------------------------
       * ROLLBACK
       *
       * Restore parent and any children that
       * were successfully changed.
       * -----------------------------------------
       */
      for (
        const updatedKey of successfullyUpdated
      ) {

        const originalQuantity =
          originalQuantities[updatedKey];

        try {

          await changeLineQuantity(
            updatedKey,
            originalQuantity
          );

          console.log(
            'Rolled back:',
            updatedKey,
            originalQuantity
          );

        } catch (rollbackError) {

          console.error(
            'Rollback failed:',
            updatedKey,
            rollbackError
          );
        }
      }

      /*
       * Restore the quantity input.
       */
      quantityInput.value =
        parentItem.quantity;

      /*
       * Refresh drawer so the customer sees
       * the original quantities again.
       */
      try {

        await refreshCartDrawer();

      } catch (refreshError) {

        console.error(
          'Unable to refresh cart after rollback:',
          refreshError
        );
      }

      /*
       * Show the actual Shopify error.
       *
       * Example:
       * "The maximum quantity of this item
       *  is already in your cart."
       */
      showQuantityError(
        childError.message
      );

      return;
    }

    /*
     * -----------------------------------------
     * STEP 3
     *
     * EVERYTHING SUCCESSFUL
     *
     * Refresh cart drawer.
     * -----------------------------------------
     */
    try {

      await refreshCartDrawer();

      console.log(
        'Parent and child quantities updated successfully.'
      );

    } catch (refreshError) {

      console.error(
        'Unable to refresh cart drawer:',
        refreshError
      );
    }

  } catch (error) {

    console.error(
      'Parent/child quantity update failed:',
      error
    );

  } finally {

    isParentChildQuantityUpdating = false;

  }

});

/* ---- End Cart Warranty Line item update On basis of PArent Line item ---- */



function getSelectedComplementaryProducts() {
  const selectedProducts = [];

  document
    .querySelectorAll('complementary-products .complementary__item')
    .forEach((item) => {
      const variantInput = item.querySelector('.complementary-variant-id');
      const quantityInput = item.querySelector('.quantity__input');

      if (!variantInput || !quantityInput) return;

      const variantId = Number(variantInput.value);
      const quantity = Number(quantityInput.value || 0);

      if (variantId && quantity > 0) {
        selectedProducts.push({
          id: variantId,
          quantity: quantity
        });
      }
    });

  return selectedProducts;
}

document.addEventListener('change', (event) => {
  if (!event.target.matches('complementary-products .quantity__input')) return;

  const products = getSelectedComplementaryProducts();

  // Toggle warranty-added class based on selected products
  const hasSelectedProducts = products.some(
    (product) => Number(product.quantity) > 0
  );

  // checkoutButton?.classList.toggle('warranty-added', hasSelectedProducts);

  // Toggle is-active based on each product's quantity
  document.querySelectorAll('complementary-products li').forEach((li) => {
    const quantityInput = li.querySelector('.quantity__input');
    const quantity = Number(quantityInput?.value || 0);

    li.classList.toggle('is-active', quantity > 0);
  });
  updateAddonMessage();
  updateCheckoutButtonClass();
});

// Info Message

// function updateAddonMessage() {
//   // Target the button group even when warranty-added is removed
//   const buttonsGroup = document.querySelector(
//     '.product-form__buttons-group'
//   );

//   if (!buttonsGroup) return;

//   let messageElement = document.querySelector('.addon-selection-message');

//   const products = getSelectedComplementaryProducts() || [];

//   const complementaryCount = products.filter(
//     (product) => Number(product.quantity) > 0
//   ).length;

//   const warrantyCount = warrantyCheckbox?.checked ? 1 : 0;
//   const totalAddons = complementaryCount + warrantyCount;

//   if (!messageElement) {
//     messageElement = document.createElement('div');
//     messageElement.className = 'addon-selection-message';
//     buttonsGroup.parentNode.insertBefore(messageElement, buttonsGroup);
//   }

//   if (totalAddons > 0) {
//     messageElement.textContent =
//       `${totalAddons} add-on${totalAddons !== 1 ? 's' : ''} selected — ` +
//       `${totalAddons !== 1 ? 'they’ll' : 'it’ll'} be added with your iPhone`;

//     messageElement.style.display = '';
//   } else {
//     messageElement.style.display = 'none';
//   }
// }

function updateAddonMessage() {
  const buttonsGroup = document.querySelector(
    '.product-form__buttons-group'
  );

  if (!buttonsGroup) return;

  let messageElement = document.querySelector('.addon-selection-message');

  const products = getSelectedComplementaryProducts() || [];

  const complementaryCount = products.filter(
    (product) => Number(product.quantity) > 0
  ).length;

  const warrantyCount = warrantyCheckbox?.checked ? 1 : 0;
  const totalAddons = complementaryCount + warrantyCount;

  if (!messageElement) {
    messageElement = document.createElement('div');
    messageElement.className = 'addon-selection-message';
    buttonsGroup.parentNode.insertBefore(messageElement, buttonsGroup);
  }

  // Hide the message when no add-ons are selected
  if (totalAddons === 0) {
    messageElement.style.display = 'none';
    messageElement.textContent = '';
    return;
  }

  messageElement.textContent =
    `${totalAddons} add-on${totalAddons !== 1 ? 's' : ''} selected — ` +
    `${totalAddons !== 1 ? 'they’ll' : 'it’ll'} be added with your device`;

  messageElement.style.display = '';
}

function updateCheckoutButtonClass() {
  const products = getSelectedComplementaryProducts() || [];

  const hasComplementaryProducts = products.some(
    (product) => Number(product.quantity) > 0
  );

  const warrantySelected = document.querySelector(
    '.techup-warranty__checkbox'
  )?.checked;

  checkoutButton?.classList.toggle(
    'warranty-added',
    hasComplementaryProducts || warrantySelected
  );
}

// Set the initial state
// updateCheckoutButtonClass();


